import { createContext } from 'react';

export interface IntakeSummaryExperimentContextValue {
  status: 'loading' | 'ready' | 'error';
  experience: 'control' | 'treatment';
}

const DEFAULT_INTAKE_SUMMARY_EXPERIMENT_CONTEXT: IntakeSummaryExperimentContextValue = {
  status: 'ready',
  experience: 'control',
};

export const IntakeSummaryExperimentContext = createContext<IntakeSummaryExperimentContextValue>(
  DEFAULT_INTAKE_SUMMARY_EXPERIMENT_CONTEXT,
);
